"use strict";

define('evisions/dynamicproperty',['vertebrae', 'evisions/helper', 'underscore'], function (Vertebrae, helper, _) {
  var EVIDynamicProperty = Vertebrae.Object.extend({
    properties: ['Dependencies', 'Owner', 'Key', 'Value'],
    initialize: function initialize(dependencies, owner, key) {
      this._super.call(this);
      this.setOwner(owner);
      this.setKey(key || '');
      this.setDependencies(dependencies || []);
    },
    start: function start() {
      this.setup();
    },
    update: function update() {
      var value = this.fetch();
      if (value instanceof Promise) {
        return Promise.resolve(value).bind(this).then(this.didFetchData);
      } else {
        this.didFetchData(value);
      }
    },
    fetch: function fetch() {},
    didFetchData: function didFetchData(data) {
      this.setValue(data);
      return data;
    },
    clear: function clear() {},
    setup: function setup() {},
    setValue: function setValue(v, silent) {
      this.set('Value', v, silent);
      return this;
    }
  }, {});
  return EVIDynamicProperty;
});

